import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import FooterPanel from "../common/FooterPanel";
import MenuBar from "../common/MenuPanel";
import UtilMethods from "../../util/UtilMethods"; // Import the utility class
import { Tooltip } from "@mui/material"; // Import Tooltip component from MUI
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faBan,
  faCheck,
  faSave,
  faFileAlt,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import eventsData from "../../source/events.json";

const EventsDetailsPage = () => {
  const events = eventsData;
  // Get the retreat type from the URL
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const retreatType = type || "all";
  const navigate = useNavigate();

  const [filteredEvents, setFilteredEvents] = useState([]);

  useEffect(() => {
    //console.log('EventsDetailsPage retreatType',retreatType); // Log filtered events
    // Load all events if retreatType is null
    const filtered = events.filter((event) =>
      retreatType === "all" ? true : event.type === retreatType
    );
    const sortedFiltered = filtered.sort(
      (a, b) => new Date(b.start_date) - new Date(a.start_date)
    );
    setFilteredEvents(sortedFiltered);
    //console.log('EventsDetailsPage filtered',filtered); // Log filtered events
  }, [retreatType]);

  const handleButtonClick = (eventId) => {
    navigate(`/retreat-registration?id=${eventId}&mode=E`);
  };

  // Function to truncate the text and show the tooltip
  const truncateText = (text, length = 200) => {
    if (!text) return "";
    if (text.length > length) {
      return text.substring(0, length) + "..."; // Truncate with ellipsis
    }
    return text; // Return the full text if it's shorter than the limit
  };

  // Function to add empty space if text length is less than 200
  const addEmptySpaceIfShort = (text, length = 200) => {
    if (text && text.length < length) {
      return <span>&nbsp;</span>; // Add a non-breaking space if text is shorter than 200 characters
    }
    return null; // No space if the text is long enough
  };

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      <div
        className="banner-image"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/Krupabhishekam-Bible-Convention-Banner.jpg)`,
        }}
      >
        <div className="banner-heading text-center wow fadeInDown">
          <h1 className="text-white">
            {retreatType && retreatType !== "all"
              ? `Upcoming Retreats (${retreatType})`
              : "Upcoming Retreats"}
          </h1>
        </div>
      </div>

      <div className="container mt-1">
        <div className="row">
          {filteredEvents.length > 0 ? (
            filteredEvents.map((event, index) => (
              <div
                key={index}
                className="col-12 col-md-6 mb-4 wow fadeInUp" // Add wow and fadeInUp classes
                data-wow-delay={`${0.3 * (index + 1)}s`} // Add delay for staggered animation
              >
                <div className="card">
                  <div className="card-body">
                    <h5 className="card-title">
                      <a
                        href={`${process.env.PUBLIC_URL}/images/Retreat_${event.id}.jpg`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {UtilMethods.formatDateDDMONYYY(event.start_date)} -{" "}
                        {event.name}
                        {" : "}
                        <FontAwesomeIcon icon={faFileAlt} />
                      </a>{" "}
                      {event.reg_type !== "NO" &&
                      UtilMethods.canRegister(
                        event.reg_date,
                        event.reg_end_date
                          ? event.reg_end_date
                          : event.start_date
                      ) && (
                        <button
                          className="mt-0 mb-0 align_right btn btn-primary "
                          onClick={() => handleButtonClick(event.id)}
                        >
                          Register
                        </button>
                      )}
                    </h5>
                    <p>
                      <i className="fa fa-calendar" aria-hidden="false"></i>
                      {" Date : "}
                      {UtilMethods.formatDate(event.start_date)} to{" "}
                      {UtilMethods.formatDate(event.end_date)}
                    </p>
                    <p>
                      {" "}
                      <i className="fa-solid fa-clock"></i> Time :{" "}
                      {event.timings}
                    </p>

                    {/*
                      Description with Tooltip and empty space if text length is less than 200
                    */}
                    <Tooltip title={event.description} arrow>
                      <p className="mb-1 mt-1">
                        {truncateText(event.description)}
                        {addEmptySpaceIfShort(event.description)}
                      </p>
                    </Tooltip>

                    {event.fee && (
                      <>
                        <h6 className="mb-1 mt-1">{"Fees"}</h6>
                        <p className="mb-1 mt-1">
                          {truncateText(
                            UtilMethods.formatTextWithLineBreaks(event.fee)
                          )}
                          {addEmptySpaceIfShort(
                            UtilMethods.formatTextWithLineBreaks(event.fee)
                          )}
                        </p>
                      </>
                    )}

                    <h6 className="font-weight-bold mt-1 mb-1">Contact Details</h6>
                    {/* Contact with Tooltip and empty space if text length is less than 200 */}
                    <Tooltip title={event.contact} arrow>
                      <p className="mb-1 mt-1">
                        {truncateText(event.contact)}
                        {' Email: '}<a href={`mailto:${event.retreatEmail}`}>{event.retreatEmail}</a><br/>
                        {addEmptySpaceIfShort(event.contact)}
                      </p>
                    </Tooltip>

                    {event.map && (
                      <div className="mt-1 mb-1">
                        <h6 className="mb-1 mt-1">Location</h6>
                        <a
                          className="fa fa-location-arrow"
                          href={event.map}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`Location of ${event.name}`}
                          style={{ fontSize: "0.8rem" }}
                        >
                          {" "}
                          {event.location}
                        </a>
                      </div>
                    )}
                  {event.reg_type === "NO" ? (
                    <p style={{ margin: "10px 0" }}>
                      <i>
                        Registration is not required for this event.
                      </i>
                    </p>
                  ) : UtilMethods.canRegister(
                    event.reg_date,
                    event.reg_end_date ? event.reg_end_date : event.start_date
                  ) ? (
                    <button
                      className="btn btn-primary mt-2"
                      onClick={() => handleButtonClick(event.id)}
                    >
                      Register
                    </button>
                  ) : new Date(event.reg_end_date) < new Date() ? (
                    <p style={{ margin: "10px 0" }}>
                      <i style={{ color: "red" }}>
                        Registration is Closed. WALK-INS will NOT BE PERMITTED {/*Please contact{" "}
                        <a href="mailto:retreat@graceanointing.org">
                          retreat@graceanointing.org
                        </a>{" "}
                        if you have any questions*/}
                      </i>
                    </p>
                  ) : (
                    <p style={{ margin: "10px 0" }}>
                      <i>
                        Registration opens on{" "}
                        {UtilMethods.formatDate(event.reg_date)}
                      </i>
                    </p>
                  )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">
              No upcoming {retreatType !== "all" ? retreatType : ""} events at
              the moment. Please check back later or visit the
              <a
                href="https://marianretreatcentre.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Marian Retreat Centre
              </a>{" "}
              for more events.
            </p>
          )}
        </div>
      </div>

      <div className="container mt-4">
        <p className="text-justify">
          <i>
            <u>Note:</u> This section provides details of the retreats planned
            across the US region only. For all other retreats and conventions,
            please visit Marian Retreat Centre's website.
          </i>
          <a className="link" href="https://marianretreatcentre.org/">
            | Marian Retreat Centre |{" "}
            <i className="bi bi-arrow-right-circle"></i>
          </a>
        </p>
      </div>

      <FooterPanel />
    </React.Fragment>
  );
};

export default EventsDetailsPage;
